/**
 * Footer section: quote carousel, bottom-logo reveal and the newsletter signup form.
 *
 * @namespace footer
 */

import {register} from '@/scripts/core/sections';
import {getCssVar} from '@/scripts/utils/helpers';

const QUOTE_INTERVAL = 5000;

function isEmail(email) {
    return Boolean(email && email.match(/.+@.+\.[a-z]{2,}/));
}

register('footer', {

    onLoad() {
        this.quotes = this.container.querySelectorAll('.footer__quote__container-child');

        this.initMediaQuery();
        this.footerAnimations();
        this.footerCarousel();
        this.initSignup();
    },

    initMediaQuery() {
        const small = getCssVar('small') || '750px';
        this.desktopMq = window.matchMedia(`(min-width: ${small})`);
    },

    footerCarousel() {
        const quotes = this.quotes;
        if (!quotes.length) {
            return;
        }

        const counter = this.container.querySelector('#footer__quote__counter');
        let currentItem = 0;

        const interval = window.setInterval(() => {
            currentItem = (currentItem + 1) % quotes.length;
            quotes.forEach((quote) => quote.classList.remove('shown'));
            quotes[currentItem].classList.add('shown');
            if (counter) {
                counter.textContent = currentItem + 1;
            }
        }, QUOTE_INTERVAL);
        this.cleanup(() => window.clearInterval(interval));
    },

    footerAnimations() {
        if (!this.desktopMq.matches) {
            return;
        }

        const bottom = this.container.querySelector('#footer-bottom');
        if (!bottom) {
            return;
        }

        // Toggle on the viewport's bottom edge (the old ScrollMagic triggerHook: 1):
        // on while #footer-bottom is in view or scrolled past, off when it's back below the fold.
        const logos = this.container.querySelectorAll('.footer__bottom__logo');
        const observer = new IntersectionObserver(([entry]) => {
            const passed = entry.isIntersecting || entry.boundingClientRect.top < 0;
            logos.forEach((logo) => logo.classList.toggle('slide-up', passed));
        });
        observer.observe(bottom);
        this.cleanup(() => observer.disconnect());
    },

    initSignup() {
        this.container.querySelectorAll('.footer-signup form').forEach((form) => {
            this.on(form, 'submit', (event) => this.onSignupSubmit(event, form));
        });
    },

    onSignupSubmit(event, form) {
        event.preventDefault();

        const input = form.querySelector('input[name="email"]');
        const email = input ? input.value : undefined;
        if (!isEmail(email)) {
            alert('Please provide a valid email address.');
            return;
        }

        const signups = this.container.querySelectorAll('.footer-signup');
        const messages = () => this.container.querySelectorAll('.footer-signup p');

        input.style.display = 'none';
        signups.forEach((signup) => signup.insertAdjacentHTML('beforeend', '<p>Processing...</p>'));

        window.wb_apihelper({
            vendor: 'klaviyo-subscribe',
            action: 'subscribe',
            email,
            list_id: 'QMJ7TG',
            signup_location: 'Footer',
        }, (err) => {
            if (err) {
                messages().forEach((message) => message.remove());
                input.style.display = '';
                alert('Sorry there was an issue saving your email. Please try again or contact support.');
                return;
            }

            messages().forEach((message) => {
                message.textContent = "You're in!";
            });
            this.container.querySelectorAll('.footer-signup form').forEach((signupForm) => signupForm.remove());
        });
    },
});
